<template>
  <div
    class="mx-auto flex w-full max-w-[360px] flex-col items-center gap-3 px-5 pb-2 pt-4"
    data-test="chat-conference-created-welcome"
  >
    <contact-avatar
      class="shrink-0"
      :room="room"
      :name="room.name"
      :size="96"
      is-room
      square
    />
    <p
      class="line-clamp-3 wrap-break-word text-center text-heading-m-18-24 text-fg-base-fg3"
      data-test="chat-conference-created-welcome-name"
    >
      {{ room.name }}
    </p>
    <div
      v-if="showActions"
      class="flex w-full flex-wrap items-center justify-center gap-2"
    >
      <wui-btn
        variant="neut"
        state="tonal"
        :size="32"
        class="shrink-0 text-nowrap text-body-m-14-20! bg-surf-neut-soft-def! text-surf-brand-basedarkblue-def! hover:bg-surf-neut-soft-hov! active:bg-surf-neut-soft-pres!"
        data-test="chat-conference-created-add-participants"
        @click="onAddParticipants"
      >
        {{ $t('calls.addParticipants') }}
      </wui-btn>
      <wui-btn
        variant="neut"
        state="tonal"
        :size="32"
        class="shrink-0 text-nowrap text-body-m-14-20! bg-surf-neut-soft-def! text-surf-brand-basedarkblue-def! hover:bg-surf-neut-soft-hov! active:bg-surf-neut-soft-pres!"
        data-test="chat-conference-created-settings"
        @click="onOpenSettings"
      >
        {{ $t('common.settings') }}
      </wui-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDialog, WuiBtn } from '@wui/common-library'
import { computed } from 'vue'

import { AddChatParticipantsModal } from '@/features/add-chat-participants'

import { ContactAvatar } from '@/entities/contact-avatar'
import { useModeratedRoom } from '@/entities/room'

import { useGuestAuth } from '@/shared/composables/guest-auth'
import { isGuest } from '@/shared/composables/local-storage'
import { openChatAside } from '@/shared/composables/use-open-chat-aside'
import { Room } from '@/shared/types/store'

const props = defineProps<{
  room: Room
}>()

const { showDialog } = useDialog()
const { currentGuest } = useGuestAuth()
const roomRef = computed(() => props.room)
const { canIEditRoomInfo } = useModeratedRoom(roomRef)

const isGuestUser = computed(() => isGuest() || Boolean(currentGuest.value))
const showActions = computed(() => (
  props.room.isGroup && Boolean(canIEditRoomInfo.value) && !isGuestUser.value
))

const onAddParticipants = () => {
  showDialog(AddChatParticipantsModal, {
    id: 'AddChatParticipantsModal',
    room: props.room,
    hasOverlay: true,
  })
}

const onOpenSettings = () => {
  openChatAside({ openGroupSettings: true })
}
</script>

